'use strict';

import _ from 'underscore';
import { ABOUT_PAGE } from '../constants';

export function getAboutMeUrl(array) {
    const currentLink = _.find(array, (link) => {
        if (link && link.url) {
            const url = link.url.toLowerCase();
            return url === ABOUT_PAGE.URL_PATHS.ABOUT ||
                url === ABOUT_PAGE.URL_PATHS.ABOUT_ME;
        }
    });

    return currentLink && currentLink.url;
}



// WEBPACK FOOTER //
// ./components/about_page/selectors.js